import { createClient as createClientV1 } from './generated/v1/client';
import { createClient as createClientV2 } from './generated/v2/client';
import { createClient as createClientV3 } from './generated/v3/client';
import { createConfiguredClient } from '../shared/createBffClient';
import type { BffClientOptions } from '../shared/types';
export function createBffClient(options: BffClientOptions) {
  return createConfiguredClient(createClientV2, options);
}
export function createBffClientV1(options: BffClientOptions) {
  return createConfiguredClient(createClientV1, options);
}
export function createBffClientV3(options: BffClientOptions) {
  return createConfiguredClient(createClientV3, options);
}